import React from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Input,
  Modal,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
  FormGroup,
  Label,
} from "reactstrap";
import img from "../../assets/img/custom/94 cents .jpg";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import { getAds } from "store/actions/adsAction";
import { addAdsViews } from "store/actions/adsAction";
import { getCategories } from "store/actions/adsAction";

const Bargains = () => {
  let dispatch = useDispatch();
  const [category, setCategory] = useState("All");
  const [filteredAds, setFilteredAds] = useState([]);
  let [loader, setLoader] = useState({
    data: false,
    loadMore: false,
  });
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [checkWarning, setCheckWarning] = useState(false);
  const [siteUrl, setSiteUrl] = useState(false);
  const [collectionId, setCollectionId] = useState("");
  const [ip, setIp] = useState("");
  let { ads, lastDocument, hasMoreDocument } = useSelector(
    (state) => state.ads
  );
  const toggle = () => {
    setIsOpenModal(!isOpenModal);
    setCheckWarning(false);
  };

  useEffect(() => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getAds("", category, () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
    const fetchIp = async () => {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        setIp(data.ip);
      } catch (error) {
        console.error("Error fetching the IP address:", error);
      }
    };

    fetchIp();
    dispatch(getCategories(() => {}));
  }, []);

  let loadMore = () => {
    setLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    dispatch(
      getAds(lastDocument, category, () => {
        setLoader((prev) => ({
          ...prev,
          loadMore: false,
        }));
      })
    );
  };
  const handleShowAds = () => {
    window.open(siteUrl, "_blank", "noopener,noreferrer");
    dispatch(
      addAdsViews(collectionId, {
        fan_id: ip,
        fan_name: "Guest",
        fan_email: "Guest",
      })
    );
    toggle();
  };
  useEffect(() => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getAds("", category, () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  }, [category, dispatch]);

  return (
    <>
      <Container className="py-4">
        <h1 className="text-center mt-4">Great DEALS!</h1>
        <Card className="p-4">
          <Row>
            <Col className="col-4">
              <FormGroup>
                <Label for="exampleSelect">Category</Label>
                <Input
                  required
                  id="exampleSelect"
                  name="select"
                  type="select"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                >
                  <option value="All">All</option>
                  <option value="TL">I: TL - Travel/Lodging</option>
                  <option value="FB">II: FB - Food & Beverage</option>
                  <option value="PCHG">
                    III: PCHG - Personal Care/Home Goods
                  </option>
                  <option value="ET">IV: ET - Entertainment</option>
                  <option value="RT">V: RT - Retail</option>
                  <option value="TEC">VI: TEC - Tech/E-Commerce</option>
                  <option value="OT">VII: OT - Other</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            {loader.data ? (
              <Col>
                <div className="text-center">
                  <Spinner color="primary" />
                </div>
              </Col>
            ) : ads?.length > 0 ? (
              <>
                {ads.map((item, index) => {
                  return (
                    <Col lg="4" className="py-2" key={index}>
                      <Card className="p-2 h-100">
                        <h4 className="text-center">
                          To VISIT VENDOR WEBSITE, CLICK AD
                        </h4>
                        {item.bidType == "image" && (
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text text-center pointer"
                            onClick={() => {
                              toggle();
                              setSiteUrl(item.website);
                              setCollectionId(item.id);
                            }}
                          >
                            <img
                              src={item.imageUrl}
                              alt=""
                              width="100%"
                              height="100%"
                            />
                          </a>
                        )}
                        {item.bidType == "video" && (
                          <div className="text-center">
                            <video width="100%" height={400} controls>
                              <source src={item.videoUrl} type="video/mp4" />
                              Your browser does not support the video tag.
                            </video>
                            <Button
                              onClick={() => {
                                toggle();
                                setSiteUrl(item.website);
                                setCollectionId(item.id);
                              }}
                              color="primary"
                              size="sm"
                            >
                              visit Site
                            </Button>
                          </div>
                        )}
                        <h3 className="text-center m-0 mt-2">
                          {`${item.description} (${item.category})`}
                        </h3>
                      </Card>
                    </Col>
                  );
                })}
              </>
            ) : (
              <h2 className="text-center">No Ads Found</h2>
            )}
          </Row>
        </Card>
        {ads.length > 4 && (
          <div className="text-center my-3">
            <Button
              color="primary"
              size="md"
              onClick={loadMore}
              disabled={!hasMoreDocument || loader.loadMore}
            >
              {loader.loadMore ? <Spinner size="sm" /> : "Load More"}
            </Button>
          </div>
        )}
      </Container>
      <Modal
        isOpen={isOpenModal}
        toggle={toggle}
        className="modal-dialog modal-dialog-centered"
      >
        <ModalHeader>
          <h1 className="text-danger">This way to visit the ad Website</h1>
          <h2>You are about to leave FansHelpPlayers:</h2>
          <h2 className="text-danger">Remember:</h2>
          <h3 className="m-0 my-2">
            Do not give your credit card information to a vendor you do not know
            and trust. 
          </h3>
          <h5 className="px-4">
            <Input
              type="checkbox"
              checked={checkWarning}
              onChange={(e) => setCheckWarning(e.target.checked)}
            />{" "}
            I will check reviews before I buy. I will not hold
            FansHelpPlayers,LLC responsible in any way for my purchase
            decisions.
          </h5>
        </ModalHeader>
        <ModalFooter className="text-right">
          <Button color="danger" onClick={toggle}>
            Cancel
          </Button>
          <Button
            disabled={!checkWarning}
            color="primary"
            onClick={handleShowAds}
          >
            Ok
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Bargains;
